import { CHANNEL_PROOFREAD_SYNONYM_SELECTION_ANALYZE_EVENT } from '@chegg-wt/core-wa/constants/pusher'
import { WtPusherEvent } from '@chegg-wt/core-wa/state/types'
import getFeatureEditor from '@chegg-wt/core-wa/utils/getEditor'
import { getSelection } from '@chegg-wt/core-wa/utils/helpers'
import { synonymsDataHandler } from '@chegg-wt/core-wa/utils//pusherDataHandlers'
import pusherManager from '@chegg-wt/core-wa/utils/pusherManager'
import { onSynonymQuickActionClickArgs } from '../types'
import { getCompleteWords } from './getCompleteSelection'

export const onSynonymQuickActionClick = async ({
  paperId,
  selectedSentenceOffSet,
  handleSynonymData,
  setIsLoadingSuggestions,
  setError,
}: onSynonymQuickActionClickArgs) => {
  const editor = getFeatureEditor()
  const { selectedText, from, to } = getSelection(editor.view?.state)

  setIsLoadingSuggestions(true)
  setError(null)
  if (!selectedText || !selectedSentenceOffSet.current) return

  const { originalText, offset, id } = selectedSentenceOffSet.current
  const oldStart = from - offset
  const oldEnd = to - offset
  const { completeWords, newStartIndex } = getCompleteWords(
    originalText,
    oldStart,
    oldEnd
  )

  const newFrom = newStartIndex + offset
  const newTo = newFrom + completeWords.length
  editor.chain().setTextSelection({ from: newFrom, to: newTo }).focus().run()

  try {
    await pusherManager.subscribe(
      CHANNEL_PROOFREAD_SYNONYM_SELECTION_ANALYZE_EVENT,
      (eventData: WtPusherEvent) =>
        synonymsDataHandler.handleSynonymFeedbackEvent(
          eventData,
          handleSynonymData,
          setIsLoadingSuggestions,
          setError
        )
    )
  } catch {
    setIsLoadingSuggestions(false)
    setError({ code: 'PUSHER_CONNECTION_ERROR', message: "Couldn't connect to pusher" })
    return
  }

  const traceId = await pusherManager.getTraceId()

  const initiatedAt = new Date().toISOString()
  synonymsDataHandler.enableSynonymFeedbackAcceptance(
    id,
    originalText,
    initiatedAt,
    traceId,
    paperId,
    completeWords.length,
    newFrom
  )

  await synonymsDataHandler.handleSynonymCall(
    traceId,
    paperId,
    [
      {
        id,
        originalText,
      },
    ],
    completeWords.length,
    newFrom - offset, // api needs sentence based offset
    initiatedAt,
    setIsLoadingSuggestions,
    setError
  )
}

export const unBindTheSynonymEventOnPusher = () => {
  pusherManager.unbind(CHANNEL_PROOFREAD_SYNONYM_SELECTION_ANALYZE_EVENT)
}
